import { render, staticRenderFns } from "./OAuthCallback.vue?vue&type=template&id=32267ccd"
import script from "./OAuthCallback.vue?vue&type=script&lang=ts"
export * from "./OAuthCallback.vue?vue&type=script&lang=ts"
import style0 from "./OAuthCallback.vue?vue&type=style&index=0&id=32267ccd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports